import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button
} from '@mui/material';

const AddConfigDialog = ({ 
    open, 
    onClose, 
    newConfig, 
    setNewConfig, 
    onSubmit 
}) => {
    const handleInputChange = (field, value) => {
        setNewConfig(prev => ({
            ...prev,
            [field]: value
        }));
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Додати нову конфігурацію AI агента</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Назва"
                    fullWidth
                    variant="outlined"
                    value={newConfig.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    sx={{ mb: 2 }}
                />
                <TextField
                    margin="dense"
                    label="Модель чату"
                    fullWidth
                    variant="outlined"
                    value={newConfig.chat_model}
                    onChange={(e) => handleInputChange('chat_model', e.target.value)}
                    sx={{ mb: 2 }}
                />
                <TextField
                    margin="dense"
                    label="Температура"
                    type="number"
                    fullWidth
                    variant="outlined"
                    value={newConfig.temperature}
                    onChange={(e) => handleInputChange('temperature', parseFloat(e.target.value))}
                    inputProps={{ min: 0, max: 2, step: 0.1 }}
                    sx={{ mb: 2 }}
                />
                <TextField
                    margin="dense"
                    label="Top K"
                    type="number"
                    fullWidth
                    variant="outlined"
                    value={newConfig.top_k}
                    onChange={(e) => handleInputChange('top_k', parseInt(e.target.value))}
                    inputProps={{ min: 1 }}
                    sx={{ mb: 2 }}
                />
                <TextField
                    margin="dense"
                    label="Top K нотаток"
                    type="number"
                    fullWidth
                    variant="outlined"
                    value={newConfig.top_k_notes}
                    onChange={(e) => handleInputChange('top_k_notes', parseInt(e.target.value))}
                    inputProps={{ min: 1 }}
                    sx={{ mb: 2 }}
                />
                <TextField
                    margin="dense"
                    label="Top K module docs"
                    type="number"
                    fullWidth
                    variant="outlined"
                    value={newConfig.top_k_module_docs}
                    onChange={(e) => handleInputChange('top_k_module_docs', parseInt(e.target.value))}
                    inputProps={{ min: 1 }}
                    sx={{ mb: 2 }}
                />
                <TextField
                    margin="dense"
                    label="Top K submodule docs"
                    type="number"
                    fullWidth
                    variant="outlined"
                    value={newConfig.top_k_submodule_docs}
                    onChange={(e) => handleInputChange('top_k_submodule_docs', parseInt(e.target.value))}
                    inputProps={{ min: 1 }}
                    sx={{ mb: 2 }}
                />
                <TextField
                    margin="dense"
                    label="Максимальна кількість токенів відповіді"
                    type="number"
                    fullWidth
                    variant="outlined"
                    value={newConfig.max_response_tokens}
                    onChange={(e) => handleInputChange('max_response_tokens', parseInt(e.target.value))}
                    inputProps={{ min: 1 }}
                    sx={{ mb: 2 }}
                />
                <TextField
                    margin="dense"
                    label="Поріг впевненості планувальника"
                    type="number"
                    fullWidth
                    variant="outlined"
                    value={newConfig.planner_confidence_threshold}
                    onChange={(e) => handleInputChange('planner_confidence_threshold', parseFloat(e.target.value))}
                    inputProps={{ min: 0, max: 1, step: 0.01 }}
                    sx={{ mb: 2 }}
                />
                <TextField
                    margin="dense"
                    label="Поріг токенів синтезу"
                    type="number"
                    fullWidth
                    variant="outlined"
                    value={newConfig.synth_tokens_threshold}
                    onChange={(e) => handleInputChange('synth_tokens_threshold', parseInt(e.target.value))}
                    inputProps={{ min: 1 }}
                    sx={{ mb: 2 }}
                />
                <TextField
                    margin="dense"
                    label="Поріг джерел синтезу"
                    type="number"
                    fullWidth
                    variant="outlined"
                    value={newConfig.synth_sources_threshold}
                    onChange={(e) => handleInputChange('synth_sources_threshold', parseInt(e.target.value))}
                    inputProps={{ min: 1 }}
                    sx={{ mb: 2 }}
                />
                <TextField
                    margin="dense"
                    label="Поріг документів синтезу"
                    type="number"
                    fullWidth
                    variant="outlined"
                    value={newConfig.synth_docs_threshold}
                    onChange={(e) => handleInputChange('synth_docs_threshold', parseInt(e.target.value))}
                    inputProps={{ min: 1 }}
                    sx={{ mb: 2 }}
                />
                <TextField
                    margin="dense"
                    label="Поріг підзапитів синтезу"
                    type="number"
                    fullWidth
                    variant="outlined"
                    value={newConfig.synth_subqueries_threshold}
                    onChange={(e) => handleInputChange('synth_subqueries_threshold', parseInt(e.target.value))}
                    inputProps={{ min: 1 }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Скасувати</Button>
                <Button onClick={onSubmit} variant="contained">Створити</Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddConfigDialog;
